import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import { SERVICES } from "../../data/services";
import { IMAGES } from "../../data/constants";
import "./Services.css";

function Services() {

  const { t } = useTranslation();

  return (
    <div className="services-page" style={{ paddingTop: 66 }}>

      {/* Hero */}
      <div className="page-hero services-page__hero">
        <img
          src={IMAGES.strip[1]}
          alt="SK Associate services — concrete floor solutions India"
          className="hero-bg"
        />

        <div className="hero-overlay" />

        <div className="hero-content container">
          <p className="section-label">{t("services_page.label")}</p>

          <h1 className="services-page__title">
            {t("services_page.title")}
          </h1>

          <p className="services-page__subtitle">
            {t("services_page.subtitle")}
          </p>
        </div>
      </div>

      {/* Grid */}
      <section className="section" style={{ background: "var(--bg)" }}>
        <div className="container">
          <div className="grid-auto services-page__grid">
            {SERVICES.map((s, i) => (
              <AnimatedSection key={s.id} delay={i * 0.06}>
                <ServiceCard service={s} />
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default Services;